export default __webpack_public_path__ + "static/media/walletIcon.fbce18c1.svg";